import { Column, Typography } from 'seagull';
import { COBStep } from "../../../ClientOnboarding.utils";
import { Introduction } from "./introduction/Introduction";
import { jsx as _jsx } from "react/jsx-runtime";
export const StepContent = _ref => {
  let {
    currentStep
  } = _ref;
  switch (currentStep) {
    case COBStep.introduction:
      return /*#__PURE__*/_jsx(Introduction, {});
    case COBStep.introVideo:
      return /*#__PURE__*/_jsx(Column, {
        gap: 16,
        children: /*#__PURE__*/_jsx(Typography, {
          children: "Watch this quick intro to learn more about our services."
        })
      });
    case COBStep.selectAPackage:
      return /*#__PURE__*/_jsx(Column, {
        gap: 16,
        children: /*#__PURE__*/_jsx(Typography, {
          children: "Choose the package that best fits your needs."
        })
      });
    default:
      return /*#__PURE__*/_jsx(Column, {
        gap: 16,
        children: /*#__PURE__*/_jsx(Typography, {
          children: "Step content goes here."
        })
      });
  }
};